<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_5">Contents</h2>
<p class="firstleft"><a href="#/Text/foreword">Foreword by Gabe Lyons</a></p>
<p class="firstleft"><a href="#/Text/introduction">Introduction: Foreplay</a></p>
<p class="firstleft"><a href="#/Text/part1#toc_marker-1"><b>Part 1: Where Did All the Sexy Christians Go?</b></a></p>
<p class="TOC_chap"><a href="#/Text/ch1#toc_marker-1-1">1 Oh My God! Sexuality Meets Spirituality</a></p>
<p class="TOC_chap"><span href="#/Text/ch2#toc_marker-1-2" title="Link target outside of Sample">2 Modesty Gone Mad</span></p>
<p class="TOC_chap"><span href="#/Text/ch3#toc_marker-1-3" title="Link target outside of Sample">3 Jesus . . . Sex Symbol?</span></p>
<p class="firstleft"><span href="#/Text/part2#toc_marker-2" title="Link target outside of Sample"><b>Part 2: Bits, Bobs and Tricky Business</b></span></p>
<p class="TOC_chap"><span href="#/Text/ch4#toc_marker-2-1" title="Link target outside of Sample">4 The Eight <i>Fun</i>damentals of Sex</span></p>
<p class="TOC_chap"><span href="#/Text/ch5#toc_marker-2-2" title="Link target outside of Sample">5 Gender Matters</span></p>
<p class="TOC_chap"><span href="#/Text/ch6#toc_marker-2-3" title="Link target outside of Sample">6 Bi Now, Gay Later?</span></p>
<p class="TOC_chap"><span href="#/Text/ch7#toc_marker-2-4" title="Link target outside of Sample">7 Limping Straight to Heaven</span></p>
<p class="TOC_chap"><span href="#/Text/ch8#toc_marker-2-5" title="Link target outside of Sample">8 Uncomfortable Sex Positions</span></p>
<p class="firstleft"><span href="#/Text/part3#toc_marker-3" title="Link target outside of Sample"><b>Part 3: The Mission of Christian Sexuality</b></span></p>
<p class="TOC_chap"><span href="#/Text/ch9#toc_marker-5-1" title="Link target outside of Sample">9 The Bent Scapegoat</span></p>
<p class="TOC_chap"><span href="#/Text/ch10#toc_marker-5-2" title="Link target outside of Sample">10 Imago Gay</span></p>
<p class="TOC_chap"><span href="#/Text/ch11#toc_marker-5-3" title="Link target outside of Sample">11 Re-Sexing the Church</span></p>
<p class="firstleft"><span href="#/Text/conclusion#toc_marker-5-4" title="Link target outside of Sample">Conclusion: The Climax</span></p>
<p class="firstleft"><span href="#/Text/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstleft"><span href="#/Text/notes#toc_marker-5-6" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/praisefor#toc_marker-5-7" title="Link target outside of Sample">Praise for <em>Redeeming Sex</em></span></p>
<p class="firstleft"><span href="#/Text/aboutauthor#toc_marker-5-8" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/forge#toc_marker-20" title="Link target outside of Sample">Forge</span></p>
<p class="firstleft"><span href="#/Text/moreivp#toc_marker-5-9" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?71a94e70